import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Es legal?',
    a: '100%. Estamos usando la Ley Federal FCRA a tu favor.'
  }, {
    q: '¿Tengo que saber mucho inglés?',
    a: 'No, las plantillas están listas y te explico todo en español.'
  }, {
    q: '¿Funciona para deudas médicas?',
    a: 'Sí, son las más fáciles de eliminar con este método.'
  }, {
    q: '¿El banco aceptará mi crédito después de esto?',
    a: 'Sí, al eliminar lo negativo, tu perfil se vuelve "limpio" para el prestamista hipotecario.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-cream py-16 md:py-24 px-4" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <h2 className="font-heading text-4xl font-bold text-center text-brand-navy mb-12" data-id="element-21">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-22">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm transition-all duration-200" data-id="element-23">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-24">
                <span className="font-heading text-xl font-bold text-brand-navy" data-id="element-25">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-brand-gold flex-shrink-0" data-id="element-26" /> : <ChevronDown className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-27" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-28">
                <p className="font-body text-gray-600 text-lg" data-id="element-29">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}